"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const partners = [{
  name: "Marriott",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/partner_marriott_hospitality.png"
}, {
  name: "Sheraton",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/partner_sheraton_hotels.png"
}, {
  name: "Le Meridien",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/partner_le_meridien_luxury.png"
}, {
  name: "Cisco",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/partner_cisco_security.png"
}, {
  name: "Fortinet",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/partner_fortinet_protection.png"
}];
export default function SicherheitVertrauen() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section data-section-id="221614" id="gold-standard-security" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Separator className="mb-10 md:mb-12 bg-border/50" />
          
          <div className="flex flex-col items-center">
            <h2 className="text-2xl md:text-3xl font-bold font-default text-foreground mb-10 text-center tracking-tight uppercase">
              Gold-Standard Security Partners
            </h2>
            
            <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 w-full">
              {partners.map((partner, i) => <div key={i} data-index={i} className="w-28 h-12 md:w-36 md:h-16 flex items-center justify-center rounded-md bg-accent/5 backdrop-blur-sm border border-border/20 shadow-sm">
                  <img src={partner.logo} alt={`${partner.name} Logo`} className="max-w-[80%] max-h-[70%] object-contain grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all duration-500 cursor-pointer brightness-125" />
                </div>)}
            </div>
          </div>

          <Separator className="mt-10 md:mt-12 bg-border/50" />
        </div>
      </div>
    </section>;
}